// All calls to the JS tree object should be done via $.jstree.reference(self.chooser)
// Anything else and the boundaries will crash due to the tree being destroyed and recreated.

define('editor/edit/layers/add/boundaries/index',['durandal/app', 'plugins/http', 'knockout', 'knockout-mapping', 'jquery', 'jstree'], function (app, http, ko, komapping, $) {
    var viewmodel = function () {
        var self = this;

        self.tree = null;
        self.labelsVisible = ko.observable(true);
        self.filterToOnlyInView = ko.observable(false);
        self.query = ko.observable('');

        self.executeQuery1 = ko.computed(function () {
            if (self.query().length >= 2) {
                self.reloadBoundariesAndSearchResults();
        }
            else if (self.bindTree && !self.filterToOnlyInView()) {
                if ($.jstree.reference(self.chooser).get_container().find("li").length > 1) {
                    $.jstree.reference(self.chooser).destroy();
                    self.bindTree([]);
                }
            }
        }).extend({ rateLimit: 500 });

        self.executeQuery2 = ko.computed(function () {
            if (self.filterToOnlyInView()) {
                self.reloadBoundariesAndSearchResults();
            }
            else if (!self.filterToOnlyInView() && self.query().length >= 2) {
                self.reloadBoundariesAndSearchResults();
            }
            else if (self.bindTree && self.query().length < 2) {
                if ($.jstree.reference(self.chooser).get_container().find("li").length > 1) {
                    $.jstree.reference(self.chooser).destroy();
                    self.bindTree([]);
                }
            }
        }).extend({ rateLimit: 500 });

        self.activate = function (mapId, cancelFunc) {
            self.mapId = mapId;

            self.exit = function () {
                // clear currently selected shapes showing on the map
                app.trigger('map:boundaries:preview');
                $.jstree.reference(self.chooser).deselect_all();
                app.trigger('map:boundaries:exitNew');
                cancelFunc();
            };

            app.on('map:moveend', self.reloadBoundariesAndSearchResults);

            app.trigger('map:boundaries:new');
        };


        // Returns a function, that, as long as it continues to be invoked, will not
        // be triggered. The function will be called after it stops being called for
        // N milliseconds. If `immediate` is passed, trigger the function on the
        // leading edge, instead of the trailing.
        self.debounce = function (func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        };
        
        self.bindTree = function (initialNodes) {
            self.chooser.jstree({
                'plugins': ["wholerow", "checkbox", "contextmenu"],
                'core': {
                    'check_callback': true,
                    'data': function (obj, cb) {
                        if (initialNodes[0] === undefined || obj.id != "#") {
                            self.loadBoundaryNames(obj).then(function (nodes) {
                                cb.call(this, nodes);
                            });
                        } else {
                            cb.call(this, initialNodes);
                        }
                    },
                    'themes': {
                        'icons': false
                    }
                },
                'checkbox': {
                    'three_state': false
                },
                'contextmenu': {
                    'select_node': false,
                    'items': {
                        'Select children': {
                            'label': "Select children",
                            'action': function (data) {
                                var inst = $.jstree.reference(data.reference);
                                var item = inst.get_node(data.reference);
                                $.jstree.reference(self.chooser).select_node(item.children, true);
                                self.loadBoundariesFromArray(item.children);
                            }
                        },
                        'De-select children': {
                            'label': "De-select children",
                            'action': function (data) {
                                var inst = $.jstree.reference(data.reference);
                                var item = inst.get_node(data.reference);
                                $.jstree.reference(self.chooser).deselect_node(item.children, true);
                                self.unLoadBoundariesFromArray(item.children);
                            }
                        }
                    }
                }
            });

            setTimeout(function () {
                    self.bindBoundaryFilter();
            }, 200);
        };

        self.compositionComplete = function () {
            self.chooser = $("div.chooser");

            var nodes = [];
            self.bindTree(nodes);
            self.tree = $.jstree.reference(self.chooser);
        };

        self.bindBoundaryFilter = function () {

            self.chooser.on("changed.jstree", function (e, edata) {
                //check if selected or deselected
                if (edata.action == "select_node") {
                    self.loadBoundariesFromArray( [ edata.node.id ] );
                }
                else if (edata.action == "deselect_node")
                {
                    // hide the deselected boundary
                    self.unLoadBoundaryFromId(edata.node.id);
                }

            });
        };

        // this is called to clear and redraw the map after it has been moved / zoomed (after the 2 second delay)
        // all the boundaries selected are looped and sent as an array
        self.reloadBoundariesAndSearchResults = self.debounce(function () {
            app.trigger('spinner:show');
            app.trigger('map:boundaries:clear');
            var deferredAjaxCalls = [];
            try {

                if (self.filterToOnlyInView() || self.query()) {
                    deferredAjaxCalls.push(self.loadBoundariesFromSearchNoDebounce());
                } else {

                    $.jstree.reference(self.chooser).get_selected().forEach(function (value) {
                        deferredAjaxCalls.push(self.loadBoundaryFromId(value));
                    });
                }
            } catch (e) {
                app.trigger('spinner:hide');
            }

            $.when.apply(null, deferredAjaxCalls).done(function () {
                app.trigger('spinner:hide');
            });

        }, 2000);

        self.loadBoundariesFromArray = function (array) {
            app.trigger('spinner:show');
            var deferredAjaxCalls = [];

            try {
                array.forEach(function (value) {
                    // check if layer already exists on the map
                    var alreadyExists = self.checkExistingBoundaries(value);

                    if (!alreadyExists) {
                        deferredAjaxCalls.push(self.loadBoundaryFromId(value));
                    }
                });
            } catch (e) {
                app.trigger('spinner:hide');
            }

            $.when.apply(null, deferredAjaxCalls).done(function () {
                app.trigger('spinner:hide');
            });

        };

        //Accepts a single id and loads a AJAX request for the boundry
        self.loadBoundaryFromId = function (value) {
            var fullBounds = app.map.getmapBounds();
            var mapBounds = app.viewportControl.getBoundingBox();
            mapBounds.zoom = fullBounds.zoom;
            var url = '/api/boundaries/',
                data = {
                    boundaryIds: value
                };

            $.extend(data, mapBounds);

            return http.post(url, data).then(function (result) {
                var boundaries = result.data.boundaries;
                app.trigger('map:boundaries:preview', boundaries, true);
            });
        };

        self.unLoadBoundariesFromArray = function (array) {
            app.trigger('spinner:show');

            try {
                app.map.map.eachLayer(function (mapLayer) {
                    if (mapLayer.properties !== undefined) {
                        if (mapLayer.properties.id !== undefined) {
                            if (array.indexOf(mapLayer.properties.id.toString()) > -1) {
                                app.map.map.removeLayer(mapLayer);
                            }
                        }
                    }
                });
            } catch (e) {
                app.trigger('spinner:hide');
            }

            app.trigger('spinner:hide');
        };

        // loops through the layers on the map and hides a single boundry deselected in the tree view
        self.unLoadBoundaryFromId = function (id) {
            app.map.map.eachLayer(function (mapLayer) {
                if (mapLayer.properties !== undefined) {
                    if (mapLayer.properties.id !== undefined) {
                        if (mapLayer.properties.id === id) {
                            app.map.map.removeLayer(mapLayer);
                        }
                    }
                }
            });
        };
        
        // debounce this so that we limit it the the most recent call every 2 seconds to reduce wasted ajax calls
        self.loadBoundariesFromSearch = self.debounce(function () {
            app.trigger('spinner:show');
            var url;
            if (self.filterToOnlyInView()) {
                var fullBounds = app.map.getmapBounds();
                var mapBounds = app.viewportControl.getBoundingBox();
                mapBounds.zoom = fullBounds.zoom;
                url = '/api/boundaries/visible/' + self.query();

                http.post(url, mapBounds).then(function (result) {
                    //todo later
                    //bindParentsAndChildrenResultsToTree(boundaries);
                    self.bindBoundaryResultsToTree(result.data.boundaries);
                    app.trigger('spinner:hide');
                });
            } else {
                url = '/api/boundaries/info/search/' + self.query();

                http.get(url).then(function (result) {
                    if (result.success) {
                        self.bindBoundaryResultsToTree(result.data.boundaries, true);
                        app.trigger('spinner:hide');
                    }
                });
            }
        }, 2000);

        //Copy of thea bove function but without the debounce function
        self.loadBoundariesFromSearchNoDebounce = function() {
            var url;
            if (self.filterToOnlyInView()) {
                var fullBounds = app.map.getmapBounds();
                var mapBounds = app.viewportControl.getBoundingBox();
                mapBounds.zoom = fullBounds.zoom;
                url = '/api/boundaries/visible/' + self.query();

                http.post(url, mapBounds).then(function (result) {
                    //todo later
                    //bindParentsAndChildrenResultsToTree(boundaries);
                    self.bindBoundaryResultsToTree(result.data.boundaries, true);
                    app.trigger('spinner:hide');
                });
            } else {
                url = '/api/boundaries/info/search/' + self.query();

                http.get(url).then(function (result) {
                    if (result.success) {
                        self.bindBoundaryResultsToTree(result.data.boundaries, true);
                        app.trigger('spinner:hide');
                    }
                });
            }
        };

        //Todo later, turn the results into a parent / child data node
        self.bindParentsAndChildrenResultsToTree = function (boundaries) {
            var parentResults = $.grep(result.data.boundaries, function (n, i) {
                return n > 0;
            });
        };

        self.bindBoundaryResultsToTree = function (boundaries, isTextSearch) {
            var boundary,
                nodes = [];
            if (boundaries.length > 0) {
                for (var i = 0; i < boundaries.length; i++) {
                    boundary = boundaries[i];
                    var isSelected = self.checkExistingBoundaries(boundaries[i].id);
                    var textToDisplay;
                    if (isTextSearch) {
                        textToDisplay = boundary.internationalName;
                        textToDisplay += boundary.hierachy === undefined ? "" : ", " + boundary.hierachy;
                    } else {
                        textToDisplay = boundary.internationalName;
                    }

                    nodes.push({
                        id: boundary.id,
                        text: textToDisplay,
                        children: boundary.children > 0,
                        state: {
                            selected: isSelected
                        }
                    });
                }

                if ($.jstree.reference(self.chooser).get_selected().count > 0) {
                    $.jstree.reference(self.chooser).deselect_all();
                }

                $.jstree.reference(self.chooser).destroy();
                self.bindTree(nodes);
            } else {
                alert("No boundaries found");
            }

        };

        self.checkExistingBoundaries = function(id) {
            var alreadyExists = false;
            app.map.map.eachLayer(function(mapLayer) {
                if (mapLayer.properties !== undefined) {
                    if (mapLayer.properties.id !== undefined) {
                        if (mapLayer.properties.id === id) {
                            alreadyExists = true;
                        }
                    }
                }
            });
            return alreadyExists;
        };

        self.loadBoundaryNames = function (node) {
            var url = '/api/boundaries/info/' + (node.id === '#' ? 0 : node.id);

            return http.get(url).then(function (result) {
                if (result.success) {
                    var boundaries = result.data.boundaries;
                    var boundary,
                        nodes = [];
                    for (var i = 0; i < boundaries.length; i++) {
                        boundary = boundaries[i];
                        var isSelected = self.checkExistingBoundaries(boundary.id);
                        nodes.push({
                            id: boundary.id,
                            text: boundary.internationalName,
                            children: boundary.children > 0,
                            state: {
                                selected: isSelected
                            }
                        });
                    }

                    return nodes;
                }
            });
        };

        self.mapMoved = function (bounds) {
            self.bounds = bounds;
        };

        self.save = function () {
            var url = "/api/boundaries/create",
                data = {
                    editorMapId: self.mapId,
                    boundaryIds: $.jstree.reference(self.chooser).get_selected(),
                    labelsVisible: self.labelsVisible()
                };

            return http.post(url, data)
                .then(function () {

                    // exit will cause the layer list component to re-initialise
                    self.exit();
                }).fail(app.showError);
        };
    };

    return viewmodel;
});

